module.exports = __webpack_public_path__ + "static/media/col_camp_football_field.d73f32c6.jpg";